export enum ActionErrorCode {
  InvalidClient = 7210,
  Unexpected = 7299,
}

export enum ActionType {
  ActionGroup = 20,
  EventGroup = 25,
}
